import { useThemeEval } from "./use-theme-eval";
import { theme } from '@shapeable/theme';
import { mapValues, omit, get, includes } from 'lodash';
import { useThemeMode } from "./use-theme-mode";
export var useThemeColors = function (colors) {
  var $ = useThemeEval();
  return mapValues(colors, function (color) {
    return $(theme.COLOR(color));
  });
};
var removeDynamicColors = function (colors) {
  return omit(colors || {}, 'active', 'hover', 'sticky');
};
var applyStateColors = function (colors, state) {
  var _a = state || {
      isActive: false,
      isSticky: false
    },
    _b = _a.isActive,
    isActive = _b === void 0 ? false : _b,
    _c = _a.isSticky,
    isSticky = _c === void 0 ? false : _c;
  var themeMode = useThemeMode();
  var modeColors = mapValues(colors, function (color, key) {
    var _a;
    if (themeMode === 'dark') {
      if (includes(['active', 'hover', 'sticky'], key)) {
        /* @ts-ignore */
        return mapValues(colors[key], function (color, key) {
          var _a;
          /* @ts-ignore */
          return ((_a = colors.dark) === null || _a === void 0 ? void 0 : _a[key]) || colors[key];
        });
      }
      /* @ts-ignore */
      return ((_a = colors.dark) === null || _a === void 0 ? void 0 : _a[key]) || colors[key];
    }
    /* @ts-ignore */
    return colors[key];
  });
  /* @ts-ignore */
  var staticColors = removeDynamicColors(modeColors);
  // work out the correct static colors given the current state
  return mapValues(staticColors, function (color, key) {
    if (isSticky) {
      if (isActive) {
        return get(colors, "sticky.active.".concat(key), get(colors, "sticky.".concat(key), color));
      }
    }
    if (isActive) {
      return get(colors, "active.".concat(key), color);
    }
    return color;
  });
};
export var useStaticColorsFrom = function (items, state) {
  var $ = useThemeEval();
  return mapValues(items, function (item) {
    var stateColors = applyStateColors(item.colors || {}, state);
    return mapValues(stateColors, function (color) {
      return $(theme.COLOR(color));
    });
  });
};
export var staticColorsFrom = function (items, state) {
  return mapValues(items, function (item) {
    var stateColors = applyStateColors(item.colors || {}, state);
    return stateColors;
  });
};
export var useStaticColors = function (colors, state) {
  var $ = useThemeEval();
  var stateColors = applyStateColors(colors, state);
  return mapValues(stateColors, function (color) {
    return $(theme.COLOR(color));
  });
};
export var useStaticColorsCollection = function (colorCollection, state) {
  var $ = useThemeEval();
  return mapValues(colorCollection, function (colors) {
    return mapValues(applyStateColors(colors, state), function (color) {
      return $(theme.COLOR(color));
    });
  });
};